<template>
    <div class="notice">
        <div style=" background: #fff; padding: 16px;">

        
        <div class="noticeHead">
            <div class="title">自行采购公示</div>
            <div class="more" @click="onMore">更多 +</div>
        </div>
        <div class="announcementType" >
            <div class="text" >透明采购，公示先行 </div>
            <div class="selectNoticeType" >
                <div v-for="(item,index) in notificationTypeList" :key="item.value" :style="getStyle(index)" @click="selectItem(index)">
                    {{ item.lable }}
                </div>
            </div>
        </div>

        <el-row :gutter="28" style="width:100%">
            <el-col :span="24">
          <div class="top-left" style="padding:10px 0px 0px 0px;">
            <div class="top-left-card">
              <el-table
                :data="publicityList"
                style="width: 100%; max-height: 340px;"
                @row-click="skipAnnouncement"
                :header-cell-style="{ background: '#f5f7fa', color: '#333', fontWeight: 'bold' }"
              >
                <el-table-column label="公告标题" prop="title" width="" show-overflow-tooltip align="left"></el-table-column>
                <el-table-column label="公告类型" prop="infoTypeName" width="180" align="left" header-align="left"> </el-table-column>
                <el-table-column label="发布单位" prop="releaseUnit" width="220" align="left"> </el-table-column>
                <el-table-column label="数据来源" prop="resource" width="120" align="left" header-align="left"> </el-table-column>
                <el-table-column label="发布时间" prop="releaseDate" width="120" align="left" header-align="left"><template slot-scope="scope">{{renderDate(scope.row.releaseDate)}}</template></el-table-column>

              </el-table>
            </div>
          </div>
        </el-col>
            <!-- <el-col :span="6" v-for="(item, index) in publicityList" :key="index" >
                <div class="publicityBox" @click="skipAnnouncement(item)">
                    <div class="publicityTitle" >{{ item.title }}</div>
                    <div class="publicitySiteName" >{{item.resource}}</div>
                </div>

                <div class="publicityUnit" >
                    {{item. releaseUnit || null }}
                </div>
                <div class="publicityTime">
                   <div class="infoType" >{{ item.infoTypeName }}</div>
                </div>
                <div class="publicityTime">
                    {{item.releaseDate }}
                </div>
                     
            </el-col> -->

        </el-row>
        </div>
    </div>
</template>

<script>
import * as dayjs from 'dayjs';
import { prefixedUrlAsset } from '@/utils/constants';
export default {
    components: {},
    computed: {
    
    },
    data() {
        return {
            notificationTypeList:[
                {
                    lable:'采购公告'
                },
                {
                    lable:'更正公告'
                },
                {
                    lable:'结果公告'
                },
                {
                    lable:'单一来源公示'
                },
            ],
            selectedIndex: 0,
            publicityList:[],
            infoType:'4'
        };
    },
 
    created() {
        
        
    },
    mounted() {
        this.getSelfSourcing()
    },
    methods: {
        getSelfSourcing(){
            const params ={
                infoType:this.infoType,
                current: 1,
                rowCount: 4
            }
            this.axios.post(`${prefixedUrlAsset}/api/pubInfomation/getPubInfoList`,params).then((response) => {
                if (response.data.data) {
                    this.publicityList = response.data.data.data;
                }
            });
        },
        selectItem(index) {
            this.selectedIndex = index;
            switch (index) {
                case 0 : 
                    this.infoType='4'
                    break;
                case 1 : 
                    this.infoType='3'
                    break;
                case 2 : 
                   this.infoType='2'
                    break;
                case 3 : 
                   this.infoType='1'
                    break;
            } 
            this.getSelfSourcing()

        },
        getStyle(index) {
            if (this.selectedIndex === index) {
                return {
                    color: '#00A287' ,
                    background:  '#CCECE7 ',
                    borderRadius: '20px 20px 20px 20px',
                    margin:'0 24px',
                    fontWeight: 'bold',
                    width:'112px',
                    height:'40px',
                    display:'flex',
                    justifyContent:'center',
                    alignItems: 'center',
                    cursor: 'pointer'

                };
            } else {
                return {
                    color: '#000000',
                    fontSize: '16px',
                    margin:'0 24px',
                    fontWeight: 'bold',
                    width:'112px',
                    height:'40px',
                    display:'flex',
                    justifyContent:'center',
                    alignItems: 'center',
                    cursor: 'pointer'

                };
            }
        },
        onMore() {
            this.$router.push('/publicity');
        },

        skipAnnouncement(item){
            window.open(`/#/publicitydetail?id=`+item.id);
        },

        renderDate(val) {
            return dayjs(val).format('YYYY-MM-DD')
        },
       
    
        
    
        
        
    },
};
</script>

<style lang="less">
    .notice{
        padding: 10px 10%;
        background: #F5F5F5;
        .noticeHead{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .title{
                font-weight: bold;
                font-size: 24px;
                color: #000000;
            }
            .more{
                font-size: 14px;
                color: #9AA6B5;
                cursor: pointer;
                &:hover {
                    color: #00A287;
                    font-weight: bold;
                }
            }
        }
        .announcementType{
            display: flex;
            justify-content:space-between;
            align-items: center;
            margin-top: 15px;
            .text{
                font-weight: bold;
                font-size: 16px;
                color: #00A287;
            }
            .selectNoticeType{
                display: flex; 
                justify-content: center;
            }
        }
        .publicityBox{
            margin-top: 25px;
            height: 160px;
            background-image:  url("~@/assets/img/newHome/zcgsbg.png");
            background-repeat: no-repeat;
            background-size: 100% 160px ;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            .publicityTitle{
                font-size: 16px;
                color: #FFFFFF;
                text-align: center;
            }
            .publicitySiteName{
                font-weight: bold;
                font-size: 14px;
                color: #B8FFF5;
                margin-top: 24px;
               
            }

        }
        .publicityUnit{
            font-weight: bold;
            font-size: 14px;
            color: #00A287;
            margin-top: 16px;
            margin-left: 16px;
            height: 21px;
        }
        .publicityTime{
            font-size: 16px;
            color: #000000;
            margin-top: 15px;
            margin-left: 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .infoType{
                background: #13A88F;
                border-radius: 12px;
                font-size: 12px;
                color: #FFFFFF; 
                display: flex;
                justify-content: center;
                align-items: center;padding: 4px 15px;
            }
        }
        
    }
    /* 单元格 */
    .el-table .el-table__body td {
        cursor: pointer;
        color: #000;
    }
    .el-table .el-table__body tr:hover > td {
        color: #00A287;
        background-color: #FFFFFF;
    }
    </style>